// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from 'react';
import useShare from '@/common/hooks/useShare';
import { HTMLElementRefOf } from '@plasmicapp/react-web';
import { DefaultProfileActionsProps, PlasmicProfileActions } from './plasmic/paziresh_24_profile/PlasmicProfileActions';

// Your component props start with props for variants and slots you defined
// in Plasmic, but you can add more here, like event handlers that you can
// attach to named nodes in your component.
//
// If you don't want to expose certain variants or slots as a prop, you can use
// Omit to hide them:
//
// interface ProfileActionsProps extends Omit<DefaultProfileActionsProps, "hideProps1"|"hideProp2"> {
//   // etc.
// }
//
// You can also stop extending from DefaultProfileActionsProps altogether and have
// total control over the props for your component.
export interface ProfileActionsProps extends DefaultProfileActionsProps {}

const SHARE_BUTTON_LABEL = 'اشتراک گذاری';

function ProfileActions_(props: ProfileActionsProps, ref: HTMLElementRefOf<'div'>) {
  const share = useShare();

  // Plasmic share button only calls navigator.share (no desktop fallback) and is unnamed,
  // so we intercept its click in capture phase and run our shared share helper instead.
  const onClickCapture = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement | null;
    const button = target?.closest?.('button');
    if (!button || !button.textContent?.includes(SHARE_BUTTON_LABEL)) return;

    event.preventDefault();
    event.stopPropagation();

    const slug = props.slug;
    if (!slug) return;

    const url = `${window.location.origin}/dr/${slug}?utm_source=doctorprofile-share-button&utm_medium=doctorprofile&utm_campaign=doctorprofile`;
    void share({
      title: typeof document !== 'undefined' ? document.title : '',
      text: 'پروفایل پزشک در پذیرش۲۴',
      url,
    });
  };

  return <PlasmicProfileActions root={{ ref, onClickCapture }} {...props} />;
}

const ProfileActions = React.forwardRef(ProfileActions_);
export default ProfileActions;
